if (!customElements.get("video-media")) {
class VideoMedia extends HTMLElement {
    constructor() {
        super();
        this.videoOptions = JSON.parse(this.dataset.videoOptions || '{}');
        this._abortController = new AbortController();
        this.currentStoreName = window.Shopify.shop;
    }

    connectedCallback() {
        this.currentSection = document.getElementById(this.dataset.sectionId);
        this.controlButtonsElement = this.currentSection.querySelector(".video-control__buttons");
        this.videoContentContainer = this.currentSection.querySelector('.video-content__container');
        this.elementsToRemove = Array.from(this.videoContentContainer?.children).filter(
            (child) => !child?.classList.contains('video-control__container')
        );
        this.elementsToRemove.push(this.videoContentContainer.querySelector(".video-content__heading"))
        this.videoOptions.showCoverImage ? this.addCoverImage() : this.setupInViewObserver();
        this.videoOptions.showPlayButton ? this.addControlButtons() : this.setupInViewObserver();
    }

    setupInViewObserver() {
        this._observer = new IntersectionObserver(entries => {
            entries.forEach(entry => entry.isIntersecting ? this.play() : this.pause());
        });

        this._observer.observe(this);
    }

    setupPlayButtonEvent() {
        if (this.playButton) {
            this.playButton.addEventListener(
                "click",
                () => {
                    this.setAttribute("media-state", "manual-played");
                    this.play();
                    if (!this._observer) this.setupInViewObserver();
                },
            );
        }
        if (this.pauseButton) {
            this.pauseButton.addEventListener(
                "click",
                () => {
                    this.setAttribute("media-state", "manual-paused");
                    this.pause()
                },
            );
        }
    }

    addCoverImage() {
        this.coverImage = document.createElement("div");
        this.coverImage.classList.add("cover-image__container");
        Object.assign(this.coverImage.style, {
            zIndex: "0",
            position: "absolute",
            right: "0",
            bottom: "0",
            top: "0",
            left: "0",
            overflow: "hidden"
        });
        this.coverImage.innerHTML = this.getCoverImageMarkup();
        this.appendChild(this.coverImage);
    }

    getImageUrl() {
        ["coverDesktopImage", "coverMobileImage"].forEach(type => {
            this.videoOptions[type] = this.videoOptions[type]
                ? `//${this.currentStoreName}/cdn/shop/${this.videoOptions[type]}`
                : '';
        });
    }

    getCoverImageMarkup() {
        this.getImageUrl();
        const { coverDesktopImage, coverMobileImage } = this.videoOptions;
        if (coverDesktopImage || coverMobileImage) {
            return `
          <picture>
            ${coverDesktopImage ? `<source media="(min-width: 451px)" srcset="${coverDesktopImage}">` : ''}
            ${coverMobileImage ? `<source media="(max-width: 450px)" srcset="${coverMobileImage}">` : ''}
            <img src="${coverMobileImage || coverDesktopImage}" alt="video cover image" style="object-fit:cover; height:100%; width:100%;">
          </picture>`;
        } else {
            return `
          <svg viewBox="0 0 32 32" width="288" height="288">
            <path fill="#e0c45c" d="M28 5H4a3 3 0 0 0-3 3v15a1 1 0 0 0 1.74.67l8.15-9.08 5.6 8.09a1 1 0 0 0 1.43.22l6-4.59 5.38 5.47a1 1 0 0 0 1.7-.68V8a3 3 0 0 0-3-3"/>
            <path fill="#85203b" d="m30.71 22.4-6-6.1a1 1 0 0 0-1.32-.09l-6.68 5.13a1 1 0 0 0-.21 1.36l2.68 3.87A1 1 0 0 0 20 27h8a3 3 0 0 0 3-3v-.9a1 1 0 0 0-.29-.7"/>
            <path fill="#85203b" d="m20.82 25.43-9-13a1 1 0 0 0-1.57-.1l-9 10A1 1 0 0 0 1 23v1a3 3 0 0 0 3 3h16a1 1 0 0 0 .82-1.57"/>
            <circle cx="20" cy="12" r="2" fill="#fff98c"/>
          </svg>`;
        }
    }

    addControlButtons() {
        this.addPlayButton();
        this.addPauseButton();
        this.setupPlayButtonEvent();
    }

    removeControlButtons() {
        this.removePlayButton();
        this.removePauseButton();
    }

    addPlayButton() {
        this.playButton = document.createElement("div");
        this.playButton.classList.add("play-button__container");
        Object.assign(this.playButton.style, {
            zIndex: "9999",
            cursor: "pointer",
            display: "block",
        });
        this.playButton.innerHTML = `
        <svg viewBox="43.8 43.9 32.5 32.5" fill="none"><g clip-path="url(#clip0_895_8519)" fill="#fff"><path d="m65.326 59.513-6.705-4.874a.809.809 0 0 0-1.284.652v9.745a.806.806 0 0 0 1.284.651l6.705-4.87a.803.803 0 0 0 0-1.304"/><path d="M60 44.002c-8.918 0-16.145 7.227-16.145 16.145 0 8.916 7.227 16.14 16.146 16.14 8.916 0 16.144-7.225 16.144-16.14.001-8.918-7.228-16.145-16.144-16.145m0 29.592c-7.426 0-13.448-6.018-13.448-13.446 0-7.425 6.022-13.451 13.449-13.451 7.425 0 13.446 6.025 13.446 13.45.001 7.429-6.02 13.447-13.446 13.447"/></g></svg>`;
        this.controlButtonsElement.appendChild(this.playButton);
    }

    addPauseButton() {
        this.pauseButton = document.createElement("div");
        this.pauseButton.classList.add("pause-button__container");
        Object.assign(this.pauseButton.style, {
            zIndex: "9999",
            cursor: "pointer",
            display: "none"
        });
        this.pauseButton.innerHTML = `
        <svg viewBox="0 0 510 510" fill="#fff"><path d="M256 0C114.842 0 0 114.842 0 256s114.842 256 256 256 256-114.842 256-256S397.158 0 256 0m0 465.455c-115.493 0-209.455-93.961-209.455-209.455S140.507 46.545 256 46.545 465.455 140.507 465.455 256 371.493 465.455 256 465.455"/><path d="M318.061 139.636c-12.853 0-23.273 10.42-23.273 23.273v186.182c0 12.853 10.42 23.273 23.273 23.273s23.273-10.42 23.273-23.273V162.909c-.001-12.853-10.421-23.273-23.273-23.273m-124.122 0c-12.853 0-23.273 10.42-23.273 23.273v186.182c0 12.853 10.42 23.273 23.273 23.273s23.273-10.42 23.273-23.273V162.909c0-12.853-10.42-23.273-23.273-23.273"/></svg>`;
        this.controlButtonsElement.appendChild(this.pauseButton);
    }

    showPlayButton() {
        this.playButton.style.display = "block";
        this.pauseButton.style.display = "none";
    }

    showPauseButton() {
        this.playButton.style.display = "none";
        this.pauseButton.style.display = "block";
    }

    removePlayButton() {
        if (this.playButton) this.playButton.remove();
    }

    removePauseButton() {
        if (this.pauseButton) this.pauseButton.remove();
    }

    removeCoverImage() {
        if (this.coverImage) this.coverImage.remove();
        this.setupControlButtonVisiblityEvent();
    }

    setupControlButtonVisiblityEvent() {
        this.videoContentContainer.addEventListener('mouseleave', () => {
            if (window.innerWidth > 768) {
                setTimeout(() => {
                    if(this.playing) this.videoContentContainer.style.opacity = '0';
                }, 3000);
            }
        });

        this.videoContentContainer.addEventListener('mouseover', () => {
            this.videoContentContainer.style.opacity = '1';
        });
    }

    async play() {
        if (this.getMediaState === "manual-paused") return;
        if (this.coverImage) this.removeCoverImage();
        
        if (this.elementsToRemove.length > 0) {
            const videoContentWrapper = this.currentSection.querySelector(".video-content__wrapper");
            videoContentWrapper?.classList.remove("tw-bg-[#95272066]");
            this.elementsToRemove.forEach((element) => element?.remove())
        };

        if (!this.playing) {
            await this._getVideoPlayer();
            if (this.getAttribute("host") === "youtube" && typeof this.videoPlayer.playVideo === "function") {
                this.videoPlayer.playVideo();
                this.setAttribute("playing", "");
                this.showPauseButton();
            } else if (this.videoPlayer && typeof this.videoPlayer.play === "function") {
                this.videoPlayer.play();
                this.setAttribute("playing", "");
                this.showPauseButton();
            }
        }
    }

    async pause() {
        if (this.playing) {
            await this._getVideoPlayer();

            if (this.getAttribute("host") === "youtube" && typeof this.videoPlayer.pauseVideo === "function") {
                this.videoPlayer.pauseVideo();
                this.removeAttribute("playing");
                this.showPlayButton();
            } else if (this.videoPlayer && typeof this.videoPlayer.pause === "function") {
                this.videoPlayer.pause();
                this.removeAttribute("playing");
                this.showPlayButton();
            }
        }
    }

    async _getVideoPlayer() {
        if (this.videoPlayer) return this.videoPlayer;

        const target = this.querySelector("iframe") || this.querySelector("video");
        if (this.hasAttribute("host")) {
            this.setAttribute("loaded", "");
            if (this.getAttribute("host") === "youtube") {
                this.videoPlayer = await this._setupYouTubePlayer(target);
            } else {
                this.videoPlayer = target;
            }
        } else {
            this.videoPlayer = target;
        }
        return this.videoPlayer;
    }

    async _setupYouTubePlayer(target) {
        await this._loadYouTubeAPI();
        return new YT.Player(target, {
            events: {
                "onReady": () => {
                    this.videoPlayer.playVideo();
                    this.setAttribute("playing", "");
                    this.showPauseButton();
                },
                "onStateChange": (event) => {
                    if (event.data === YT.PlayerState.PLAYING) this.setAttribute("playing", "");
                    else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) this.removeAttribute("playing");
                }
            }
        });
    }

    async _loadYouTubeAPI() {
        if (!window.YT) {
            const script = document.createElement("script");
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            return new Promise(resolve => { window.onYouTubeIframeAPIReady = resolve; });
        }
    }

    disconnectedCallback() {
        this._abortController.abort();
        if (this._observer) this._observer.disconnect();
    }

    get playing() {
        return this.hasAttribute("playing");
    }

    get getMediaState() {
        return this.getAttribute("media-state");
    }
}

customElements.define("video-media", VideoMedia);
}
